module.exports = new __parcel__URL__("plusIcon.21e489fb.svg").toString();